import React, { useEffect, useState, useCallback } from "react";
import { getDocs, collection, doc , deleteDoc} from "firebase/firestore"
import { db, auth } from "../firebase-config";
import '../App.css';

function Submissions({isAuth}){
    const postsCollectionRef = collection(db, "Posts");
    const [postList, setpostList] = useState([]);

    const deletePost = useCallback(async (e) => {
        const postDoc = doc(db, "Posts", e);
        await deleteDoc(postDoc);
        }, []);

    useEffect(() => {
        const getPosts = async () => {
            try {
            const data = await getDocs(postsCollectionRef);
            setpostList(data.docs.map((doc) => ({ ...doc.data(), e: doc.id })));
            } catch (error) {
            console.log(error);
            }
        };
        getPosts();
        }, []);
    
        return (
            <div>
                {postList.map((post) => {
                    return (
                        
                        <div className="App">
                        {isAuth && post.id === auth.currentUser.uid && (
                            <div className = "module">
                            <h1 className="title"> 
                                {post.title}
                            </h1> 
                            <div className="desc">
                                {post.description}
                            </div>
                            <br></br>
                            <div>
                                {isAuth && post.id === auth.currentUser.uid && (<button className = "delete" onClick = {() => {
                                    deletePost(post.e);
                                }}>DELETE</button>)}
                                
                            </div>
                            <br></br>
                            <h1 className="title"> 
                                USER SUBMISSIONS
                            </h1> 
                            <div>
                            {post.submit.map((sub) => {
                                return(
                                    <div className="desc"> 
                                        {sub}
                                    </div>
                                )
                            })}
                            </div>
                            <br></br>
                            </div>
                        )}    
                        
                        </div>
                        
                    );
                })}
            </div>
        );
}

export default Submissions;